<template>
    <div>
        <coparate-congratulation :data="userData" />
        <b-row>
            <b-col cols="6" lg="3" v-for="nav in GroupLink" :key="'quick-link-'+nav.id">
                <statistic-card-link
                    :color="nav.color"
                    :icon="nav.icon"
                    :url="nav.url"
                    :statistic-title="nav.title"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12">
                <b-card >
                    <h5 class="mb-0">Pages</h5>
                    <br/>
                    <b-table
                        v-if="!pageData.length"
                        :items="pageData"
                        responsive
                        :fields="tablePageColumns"
                        show-empty
                        empty-text="No matching records found"
                        class="position-relative"
                    >
                    </b-table>
                    <table v-else class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" v-for="col in tablePageColumns" :key="col.key">
                                {{col.label}}
                            </th>
                        </tr>
                    </thead>
                    <tr v-for="(item, index) in pageData" :key="index">
                        <td class="pl-2">
                            {{item.title[currentLocale]}}
                        </td>
                        <td class="pl-2">
                            <span>{{ item.slug[currentLocale] }}</span>
                        </td>
                    </tr>
                    </table>
                    <br/>
                    <div style="display: flex; justify-content: end;">
                        <b-button
                            :to="'/pages'"
                            variant="outline-primary"
                        > View More </b-button>
                    </div>
                </b-card>
            </b-col>
            <!-- <b-col lg="4">
                <b-card>
                    <h5 class="mb-0">Sites</h5>
                    <br/>
                    <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" v-for="col in tableSiteColumns" :key="col.key">
                                {{col.label}}
                            </th>
                        </tr>
                    </thead>
                    <tr v-for="(item, index) in siteData" :key="index">
                        <td class="pl-2">
                            <div v-html="item.name[currentLocale]"/>
                        </td>
                        <td class="pl-2">
                            <span>{{ item.domain }}</span>
                        </td>
                    </tr>
                    </table>
                    <br/>
                    <div style="display: flex; justify-content: end;">
                        <b-button
                            :to="'/sites'"
                            variant="outline-primary"
                        > View More </b-button>
                    </div>
                </b-card>
            </b-col> -->
        </b-row>
    </div>
</template>

<script>
import { BRow, BCol, BCard, BButton, BLink, BTable } from 'bootstrap-vue'
import StatisticCardLink from '@core/components/statistics-cards/StatisticCardLink.vue'
import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import { kFormatter } from '@core/utils/filter'
import CoparateCongratulation from './CoparateCongratulation.vue'
import { setgroups } from 'process'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import pagesStoreModule from '@/views/pages/pagesStoreModule'
import { ref,onUnmounted } from '@vue/composition-api'
import Ripple from "vue-ripple-directive";
import sitesStoreModule from '@/views/sites/sitesStoreModule'

export default {
    components:{
        BRow, BCol, BCard, BButton, CoparateCongratulation, StatisticCardLink, BLink, BTable
    },

    directives: {
        Ripple,
    },

    computed: {
      currentLocale(){
        return this.$i18n.locale;
      },
    },

    setup(){
        const PAGES_STORE_MODULE_NAME = 'app-pages';
        if (!store.hasModule(PAGES_STORE_MODULE_NAME)) store.registerModule(PAGES_STORE_MODULE_NAME, pagesStoreModule)
        onUnmounted(() => {
            if (store.hasModule(PAGES_STORE_MODULE_NAME)) store.unregisterModule(PAGES_STORE_MODULE_NAME)
        });

        const SITE_STORE_MODULE_NAME = 'app-sites';
        if (!store.hasModule(SITE_STORE_MODULE_NAME)) store.registerModule(SITE_STORE_MODULE_NAME, sitesStoreModule)
        onUnmounted(() => {
            if (store.hasModule(SITE_STORE_MODULE_NAME)) store.unregisterModule(SITE_STORE_MODULE_NAME)
        });

        const toast = useToast();
        const userData = JSON.parse(localStorage.getItem('userData'));
        const getLocalSite = JSON.parse(localStorage.getItem('site'))
        const GroupLink = ref([
            {
                id:1,
                color:'success',
                icon:'BookOpenIcon',
                title:'Blog',
                url:'/blog'
            },
            {
                id:2,
                color:'secondary',
                icon:'FileTextIcon',
                title:'Page',
                url:'/pages'
            },
            {
                id:3,
                color:'primary',
                icon:'ImageIcon',
                title:'Banner',
                url:'/banner'
            },
            {
                id:4,
                color:'warning',
                icon:'SettingsIcon',
                title:'Setting',
                url:'/settings/general'
            }
        ]);
        const siteData = ref([])
        const tableSiteColumns = [
            { key: 'name', label: 'Name', sortable: false },
            { key: 'domain', label: 'Domain', sortable: false },
        ]
        const tablePageColumns = [
            { key: 'title', label: 'Title', sortable: false },
            { key: 'slug', label: 'Slug', sortable: false },
        ]
        const pageData = ref([])

        store.dispatch('app-sites/fetchSites', {
            limit: 5,
            order_by: 'ordering_count ASC',
        })
        .then(response => {
            siteData.value = response.data.data
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error fetching Sites",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })

        store.dispatch('app-pages/fetchData', {
            limit: 5,
            offset: 0,
            order_by:'ordering_count ASC',
            sites_id: getLocalSite.id        
        })
        .then(response => {
            pageData.value  = response.data.data
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error fetching Pages",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })

        return {
            userData,
            GroupLink,
            siteData,
            tableSiteColumns,
            tablePageColumns,
            pageData,
        }
    }
}
</script>

<style>

</style>